import React from "react";
import ReactDOM from "react-dom";
import { DISPLAYMODE } from "../SearchToolbar/DisplayMode";
import useHoverModal from "../hooks/useHoverModal";
import "./SearchCard.scss";

/**
 * Base SearchCard component that handles common card functionality:
 * - Hover modal logic for GRIDCOMPACT mode
 * - Display mode support
 * - Responsive hover behavior
 */
function SearchCard({
  displayMode = DISPLAYMODE.GRIDCOMPACT,
  enableHoverModal = false,
  externalModalDiv = null,
  positionModal = null,
  renderContent,
  renderModalContent = null,
  className = "",
  children,
}) {
  const { cardRef, shouldShowModal, mouseEventProps } = useHoverModal({
    displayMode,
    enableHoverModal,
    externalModalDiv,
    positionModal,
  });

  return (
    <div
      className={`search-card ${className}`}
      ref={cardRef}
      {...mouseEventProps}
    >
      {/* Render main card content */}
      {renderContent ? renderContent(false, displayMode) : children}

      {/* Render modal portal for GRIDCOMPACT mode */}
      {shouldShowModal && (
        ReactDOM.createPortal(
          <div className={`search-card ${className}`}>
            {renderModalContent ? renderModalContent(true, displayMode) : (renderContent ? renderContent(true, displayMode) : children)}
          </div>,
          externalModalDiv
        )
      )}
    </div>
  );
}

export default SearchCard;
